/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Sellable_Filter_LabelInputs */

const vi_product_sellable_filter_label = /** @type {(inputs: Product_Sellable_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại sản phẩm`)
};

/**

* @param {Product_Sellable_Filter_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_sellable_filter_label = /** @type {((inputs?: Product_Sellable_Filter_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Sellable_Filter_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_sellable_filter_label(inputs)
});